import { render, staticRenderFns } from "./purchaseReturnsDetails.vue?vue&type=template&id=1e034ff8&scoped=true"
import script from "./purchaseReturnsDetails.vue?vue&type=script&lang=js"
export * from "./purchaseReturnsDetails.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnsDetails.vue?vue&type=style&index=0&id=1e034ff8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e034ff8",
  null
  
)

export default component.exports